import { ButtonBase, styled, alpha } from '@mui/material';
import { Carousel } from 'views/rebranded-module/common/components';

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  gap: theme.spacing(1.5),
  alignItems: 'flex-start',
  justifyContent: 'flex-start',

  '& .TCImgContainer': {
    height: theme.spacing(33.625),
    width: '100%',
    position: 'relative',
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    backgroundColor: theme.palette.common.white,
  },
  '& .RCInfoContainer': {
    gap: theme.spacing(1.25),
    padding: theme.spacing(0, 0.5),
    flex: 1,

    '& .RCText': {
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    '& .RCStartAt': {
      textDecoration: 'underline',
      '& .RCPrice': {
        fontWeight: 700,
      },
      '&.RCSkipStartAt': {
        fontWeight: 600,
        fontSize: theme.spacing(2),
      },
    },
  },
  '& .RCBikeSpecs ': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.75, 0.5),
    borderRadius: theme.spacing(4),
    width: theme.spacing(3.25),
    height: theme.spacing(3.25),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    transition: 'border-color 0.5s, width 0.5s',
    border: '1px solid transparent',
    position: 'absolute',
    right: 0,
    top: 0,
    margin: theme.spacing(1.25),
    zIndex: 3,
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(19),
    },
    '&:hover': {
      border: `1px solid ${theme.palette.grey['100']}`,
      width: `calc(100% - ${theme.spacing(2)})`,

      '& .RCBikeSpecsText': {
        padding: theme.spacing(0, 2, 0, 1.25),
        textDecoration: 'underline',
      },
    },

    '& .RCBikeSpecsText': {
      transition: 'padding 0.5s, text-decoration 0.5s',
      fontSize: theme.typography.pxToRem(12),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textTransform: 'uppercase',
    },
  },
  '& .RCLocationIcon': {
    verticalAlign: 'super',
    height: theme.spacing(1.5),
    minWidth: theme.spacing(1.5),
    marginRight: theme.spacing(0.75),
  },
  '& .RCOldPrice': {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    color: theme.palette.grey[600],
    textDecoration: 'line-through',
  },
  '& .RCCreditsPerDay': {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: '150%',
    color: theme.palette.text.primary,
  },
  '& .RCSatus': {
    position: 'absolute',
    left: theme.spacing(1),
    top: theme.spacing(1),
    display: 'flex',
    padding: theme.spacing(0.5, 0.75),
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),zIndex: 2,
    '&.RCSoldout': {
      backgroundColor: theme.palette.secondary.dark,
    },
    '&.RCHurry': {
      backgroundColor: theme.palette.dynamicPricing.red.selected,
    },
    '&.RCValueDeal': {
      backgroundColor: theme.palette.dynamicPricing.green.selected,
    }, 
    '&.RCTentative': {
      backgroundColor: theme.palette.dynamicPricing.yellow.selected,
    },
  },
  '& .RCSatusText': {
    fontSize: theme.spacing(1.5),
    position: 'relative',
    top: theme.typography.pxToRem(1),
  },
  '& .RCDummyLayer': {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    background: 'rgba(0, 0, 0, 0.40)',
  },
}));

export const StyledCarousel = styled(Carousel)(({ theme }) => ({
  '& .CDots  button': {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  '& .CDots .react-multi-carousel-dot--active button': {
    backgroundColor: theme.palette.common.black,
  },
}));

export default StyledButtonBase;